import './faq.scss';

export class Faq {
  constructor() {
    this.initDropdowns();
  }

  initDropdowns() {
    const toggles = document.querySelectorAll('.toggle');

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const parent = toggle.closest('.dropdown-wrapper');
        const dropdown = parent.querySelector('.dropdown');
        const isActive = parent.classList.contains('active');

        if (isActive) {
          parent.classList.remove('active');
          setTimeout(() => {
            if (!parent.classList.contains('active')) {
              dropdown.style.display = 'none';
            }
          }, 400); // deve combaciare con max-height 0.4s
        } else {
          dropdown.style.display = 'block';
          // eslint-disable-next-line no-void
          void dropdown.offsetHeight;
          parent.classList.add('active');
        }
      });
    });
  }
}
